<template>
  <v-card class="partner-share">
    <v-card-title> Configuración de pagos </v-card-title>
    <v-card-subtitle>
      Configure los medios de pago en los que quiere recibir sus ingresos, puede
      cambiar esta configuración en cualquier momento
    </v-card-subtitle>
    <v-card-text>
      <h4>Cuenta de PayPal</h4>
      <p class="grey--text">Para ingresos en USD (Global)</p>
      <v-text-field
        v-model="paypalAccount"
        outlined
        dense
        placeholder="Email de PayPal"
        hint="Asegurese de escribirlo correctamente"
      />
      <h4>Cuenta de MercadoPago Argentina</h4>
      <p class="grey--text">Para ingresos en ARS (Argentina)</p>
      <v-text-field
        v-model="mpaAccount"
        outlined
        dense
        placeholder="Email de MercadoPago Argentina"
        hint="Asegurese de escribirlo correctamente"
      />
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn @click="$emit('close')" text :disabled="saving">Cancelar</v-btn>
      <v-btn color="primary" @click="save" :loading="saving">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { IPartnerToken } from '../../interfaces/IPartnerToken';
  import { Globals } from '../../modules/Globals';
  import { createQrBase64 } from '../../utils';
  import { saveAs } from 'file-saver';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import PartnersService from '../../api/services/partners.service';
  import { IPartner } from '../../interfaces/IPartner';

  @Component
  export default class PartnerShareModal extends Vue {
    @Prop() partner: IPartner;
    partnersService = new PartnersService();
    paypalAccount: string = null;
    mpaAccount: string = null;
    saving = false;

    async created() {
      this.paypalAccount = this.partner.paypalAccount;
      this.mpaAccount = this.partner.mpaAccount;
    }

    async save() {
      this.saving = true;
      try {
        const partner = await this.partnersService.saveSettings(
          this.partner.id,
          {
            paypalAccount: this.paypalAccount,
            mpaAccount: this.mpaAccount,
          }
        );

        this.$parent.$emit('saved', partner);
        this.$emit('close');
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      } finally {
        this.saving = false;
      }
    }
  }
</script>
